import { PostProps } from "../../../store/types/soc_svc";

export const post_getEmptyPost = ():PostProps => {
    return {
        body: '',
        formatted_body: undefined,
        title: '',
        status:'active',
        edited: false,
        comment_count: 0,
        comment_details: [],
        memo_competitions: [],
        memo_events: [],
        memo_hashtags: [],
        memo_images: [],
        memo_orders: [],
        memo_location: undefined,
        memo_players: [],
        memo_positions: [],
        memo_teams: [],
        memo_topics: [],
        memo_urls: [],
        memo_videos: [],
        create_datetime: '',
        last_update_datetime:'',
        player_id: '',
        external_social_id: '',
        url_metadata: [],
        url_preview: undefined,
        my_reactions:[],
        reaction_details: []
    }
}
